<template>
    
    <div  class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
              <button type="reset" @click="printReceipt" class="btn b-light btn-danger-light btn-sm">Print Receipt</button>
        </div>
        <div class="grid grid-cols-12">
  <div id="receipt"  class="receipt">
    <div class="receipt-container  ">
      <h3 class="dn_f_only text-center"><strong>समर्थ कटपीस अँड रेडिमेड</strong></h3>
      <p class="dn_f text-sm text-center">अक्कलकोट MIDC , सोलापूर</p>
      <div class="border"></div>
      <table class="table">
          <tbody>
          <tr> 
              <td   >
                  <strong class="">Name</strong> : {{customer.name}}<br>
                  
              </td>
              <td >
                   <strong class="">No</strong> : {{invDetails.id}}
                  
              </td>
            </tr> <tr>  
                    <td  ><strong class="">Contact</strong> : {{customer.cell}}</td>
                    <td><strong class="">Date</strong> : {{invDetails.entry_date}}<br></td>
          </tr>
          </tbody>
      </table>     
      <table class="receipt-table">
        <thead>
          <tr class="border">
            <th style="width:10%;text-align:center" class="dn_f">Sr.</th>
            <th style="width:40%" class="dn_f">Details </th>
            <th style="width:10%;text-align:center" class="dn_f">Qty </th>
            <th style="width:10%;text-align:center" class="dn_f">Rate</th>
            <th style="width:10%;text-align:center" class="dn_f">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item ,index) in order_items" :key="item.id">
            <td style="text-align:center">{{ index+1 }}</td>
            <td>{{ (item.stich_name)?item.stich_name:item.prd_name }}</td>
            <td style="text-align:center" >{{ item.qty*(-1) }}</td>
            <td style="text-align:right">{{ formatCurrency(item.rate) }}</td>
            <td style="text-align:right">{{ formatCurrency(item.rate * (item.qty * (-1) )) }}</td>
          </tr>
           
          
          
        </tbody> 
        <tfoot>
          <tr v-show="invDetails.delivery">
            <td colspan="5"><strong>Delivery Date : {{ invDetails.delivery }}</strong></td>
          </tr>
          <tr>
            <td colspan="4"><strong class="dn_f">एकूण रु</strong></td>
            <td>{{ formatCurrency(invDetails.total) }}</td>
          </tr>
          <tr>
            <td colspan="4"><strong class="dn_f">ऍडव्हांस</strong></td>
            <td>{{ formatCurrency(invDetails.paid) }}</td>
          </tr>
          <tr>
            <td colspan="4"><strong class="dn_f">येणे बाकी</strong></td>
            <td>{{ formatCurrency(invDetails.total-invDetails.paid) }}</td>
          </tr>
        </tfoot>
      </table> 
    </div>
  </div>
        </div>
        </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      currentDate: new Date().toLocaleDateString(),
      receiptNumber: '',
      customer:[],
      invDetails:[],
      order_items:[], 
       
    };
  },
  computed: {
    totalAmount() {
      return this.items.reduce((total, item) => total + item.quantity * item.unitPrice, 0);
    },
  },
  mounted() { 
      if(this.$route.query.q)
            this.getBasics(this.$route.query.q); 
  },
  methods: {
     async getBasics(invoiceid) {
           var self=this;
             axios.post('getInvoice',{invoiceid:invoiceid}).then(function (response) {
                         self.order_items=response.data.order_items;
                         self.employees=response.data.userDetails;
                         self.invDetails=response.data.invDetails;
                         self.customer=response.data.customer;
                        try {
                            document.getElementById("loader").remove();  
                            sel.printReceipt();
                        } catch (e) {}
                    }).then(()=>{ 
                        
                        
                        
                         self.printReceipt();
                  
                        });;
      },
    formatCurrency(value) {
      return value;//`$${value.toFixed(2)}`;
    },
    printReceipt() {
      window.print();
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@200;500&display=swap');
.dn_f { 
  font-family: 'Noto Sans Devanagari', sans-serif;
  font-size: 10px;
}
.dn_f_only { 
  font-family: 'Noto Sans Devanagari', sans-serif;
}
tbody,table,.border{
    border-bottom: 1px dashed;
}
 #receipt {
  font-family: monospace;
  width: 58mm; /* Common width for thermal printers */
  padding: 10px;
}
table {
  width: 100%;
}
td, th {
  padding: 5px;
  text-align: left;
}


@media print {
  button {
    display: none;
  }
 
 #receipt {
  font-family: monospace;
  width: 58mm; /* Common width for thermal printers */
  padding: 10px;
}
}


</style>
